<script setup lang="ts">
import { ElTag } from 'element-plus'
import { computed } from 'vue'
import { InsuranceCaseStatus } from '@/types/customer'

interface Props {
  status: InsuranceCaseStatus
  size?: 'large' | 'default' | 'small'
}

const props = withDefaults(defineProps<Props>(), {
  size: 'large'
})

const statusText = computed(() => {
  switch (props.status) {
    case InsuranceCaseStatus.open: return 'Otevřená'
    case InsuranceCaseStatus.closed: return 'Uzavřená'
    case InsuranceCaseStatus.postponed: return 'Odložená'
    default: return 'Neznámý'
  }
})

const statusType = computed(() => {
  switch (props.status) {
    case InsuranceCaseStatus.open: return 'primary'
    case InsuranceCaseStatus.closed: return 'success'
    case InsuranceCaseStatus.postponed: return 'warning'
    default: return 'info'
  }
})
</script>

<template>
  <el-tag :type="statusType" :size="size">{{ statusText }}</el-tag>
</template>
